import { gql } from "@apollo/client";

const GET_DISCIPLINES = gql`
  query GetDisciplines($filters: TagFilter, $domainId: ID) {
    disciplines(filters: $filters, domainId: $domainId) {
      nodes {
        name
        id
      }
    }
  }
`;

export { GET_DISCIPLINES };
